import type {WorkspaceMember} from '../../../../../../../contexts/WorkspaceContext'
import Avatar from '../../../../../../ui/Avatar/Avatar'
import NotificationDot from '../../../../../../ui/NotificationDot/NotificationDot'
import {getMemberDisplayName} from '@/utils/memberDisplayName'
import css from './InboxDropdownItem.module.css'
import {TextMidd, TextSmall} from "../../../../../../ui/Text";

interface InboxDropdownItemProps {
    taskName: string
    initiator: WorkspaceMember
    actionText: string
    onClick: () => void
}

const InboxDropdownItem = ({taskName, initiator, actionText, onClick}: InboxDropdownItemProps) => {
    const initiatorName = getMemberDisplayName(initiator) || initiator.username
    return (
        <div className={css.container} onClick={onClick}>
            <div className={css.avatar}>
                <Avatar
                    size={"medium"}
                    title={initiatorName}
                    color={initiator.color}
                    avatar={initiator.avatarImage}
                />
            </div>
            <div className={css.content}>
                <TextMidd className={css.task_name}>{taskName}</TextMidd>
                <TextSmall className={css.meta}>{initiatorName} {actionText}</TextSmall>
            </div>
            <NotificationDot/>
        </div>
    )
}

export default InboxDropdownItem
